"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dhsInstallerComponent = exports.DhsInstallerComponent = void 0;
const app_1 = require("app");
const Forms_1 = require("Forms");
const SignUpUtils_1 = require("Views/Partials/Components/SignUp/services/SignUpUtils");
const SignUpFormConfig_1 = require("Views/Partials/Components/SignUp/SignUpFormConfig");
const formLoad_1 = require("./formLoad");
const InstallerFormConfig_1 = require("./InstallerFormConfig");
class DhsInstallerComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.dhs-installer-signup';
        this.formWrapId = '#newsletter-form';
        this.formFields = {
            firstName: 'firstName',
            lastName: 'lastName',
            company: 'company',
            companyType: 'companyType',
            numberOfEmployees: 'numberOfEmployees',
            jobFunction: 'function',
            email: 'email',
            country: 'country',
            language: 'language',
            postalZipCode: 'postalZipCode',
        };
        this.renderLoader = (popupAriaLabel, closeButtonAriaLabel) => {
            (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Spinner, this.wrapper, null, 'newsletter-form group', popupAriaLabel, closeButtonAriaLabel);
        };
        this.renderMessage = (title, message, buttonLabel) => {
            (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Message(message, buttonLabel), this.wrapper, title, 'newsletter-form newsletter-form--message group');
        };
        this.setDefaults = (inputs) => inputs.map(input => {
            if (input.name === SignUpFormConfig_1.formControlKeys.companyType) {
                return Object.assign(Object.assign({}, input), { defaultValue: InstallerFormConfig_1.defaults[SignUpFormConfig_1.formControlKeys.companyType] });
            }
            return input;
        });
    }
    OnInit() {
        this.wrapper = $(this.formWrapId).get(0);
        this.el.forEach(el => {
            this.InitForm(el);
        });
    }
    InitForm(el) {
        const apiUrl = app_1.AttrService.data(el, 'url');
        const pageId = app_1.AttrService.data(el, 'page');
        const control = app_1.AttrService.data(el, 'control');
        const locationApiUrl = app_1.AttrService.data(el, 'location-api-base-url');
        const locationApiKey = app_1.AttrService.data(el, 'location-api-key');
        const culture = app_1.AttrService.data(el, 'culture');
        const defaultErrorMsg = app_1.AttrService.data(el, 'error-message');
        const popupAriaLabel = app_1.AttrService.data(el, 'newsletter-aria-label');
        const closeButtonAriaLabel = app_1.AttrService.data(el, 'close-button-aria-label');
        const bypassRecaptchaKey = app_1.AttrService.data(el, 'bypass-recaptcha-key');
        const additionalFormData = {
            applications: app_1.AttrService.data(el, 'applications'),
            markets: app_1.AttrService.data(el, 'markets'),
            segments: app_1.AttrService.data(el, 'segments'),
            solutions: app_1.AttrService.data(el, 'solutions'),
            subSegments: app_1.AttrService.data(el, 'subSegments'),
        };
        const countryService = SignUpUtils_1.signUpUtils.createCountryService(locationApiUrl, culture, locationApiKey);
        el.querySelector('.cta').addEventListener('click', ev => {
            ev.preventDefault();
            // open modal && show preloader
            this.renderLoader(popupAriaLabel, closeButtonAriaLabel);
            const formDataPromise = SignUpUtils_1.signUpUtils.getFormData(apiUrl, { pageId });
            const countryPromise = countryService.getDataForSelectOptions();
            const buttonLabel = $(ev.target).text().trim();
            const labels = {
                buttonLabel,
                popupAriaLabel,
                closeButtonAriaLabel,
            };
            Promise.all([formDataPromise, countryPromise])
                .then(([formData, countries]) => {
                const languages = SignUpUtils_1.signUpUtils.convertLanguages(formData.languages);
                const formItems = this.convertData(formData, countries, languages);
                const reCaptchaSiteKey = formData.reCaptchaSiteKey;
                this.renderForm(formData, formItems, additionalFormData, reCaptchaSiteKey, bypassRecaptchaKey, control, labels, pageId);
            })
                .catch(err => {
                this.renderMessage(null, err.response.data.message || defaultErrorMsg);
            });
        });
    }
    convertData(model, countries, languages) {
        return {
            consentText: model.specificFields.userConsentText,
            consentValidationMessage: model.specificFields.userConsentValidationMessage,
            chineseConsentText: model.specificFields.userChineseConsentText,
            chineseConsentValidationMessage: model.specificFields.userChineseConsentValidationMessage,
            departments: [],
            countries,
            companyTypes: (0, Forms_1.formatOptions)(model.companyTypes, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            numberOfEmployees: (0, Forms_1.formatOptions)(model.numberOfEmployees, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            explanationText: model.specificFields.explanationText,
            functions: (0, Forms_1.formatOptions)(model.functions, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            genericFields: model.genericFields,
            inputs: this.setDefaults(SignUpUtils_1.signUpUtils.formatInputs(this.formFields, model.genericFields, model.specificFields)),
            languages: SignUpUtils_1.signUpUtils.formatLanguages(languages),
            specificFields: model.specificFields,
            submitLabel: model.genericFields.submitLabel,
        };
    }
    renderForm(formData, formItems, additionalFormData, reCaptchaSiteKey, bypassRecaptchaKey, control, labels, pageId) {
        const title = formData.specificFields && formData.specificFields.titleText
            ? formData.specificFields.titleText
            : null;
        const inputObject = this.getInputObject(formItems);
        const gtmData = {
            label: labels.buttonLabel,
            title,
            control,
        };
        app_1.GTM.newsletter.open(gtmData);
        const onModelClose = () => {
            app_1.GTM.newsletter.abandon(gtmData);
        };
        if (formData.culture) {
            additionalFormData.culture = formData.culture;
        }
        const renderSpinner = () => {
            this.renderLoader(labels.popupAriaLabel, labels.closeButtonAriaLabel);
        };
        const render = {
            renderSpinner,
            renderMessage: this.renderMessage,
        };
        const hashMapTypes = {
            additionalFormData,
            formFields: this.formFields,
        };
        const signUpTypes = {
            formItems,
            inputObject,
        };
        // render form instead loader
        (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Form(signUpTypes, formData.postUrl, reCaptchaSiteKey, bypassRecaptchaKey, render, hashMapTypes, control, pageId), this.wrapper, title, 'newsletter-form group', labels.popupAriaLabel, labels.closeButtonAriaLabel, onModelClose);
    }
    getInputObject({ inputs, countries, companyTypes, numberOfEmployees, functions, genericFields, specificFields, languages, }) {
        const inputObject = inputs.reduce((acc, currentValue) => {
            acc[currentValue.name] = currentValue;
            return acc;
        }, {});
        inputObject.country.options = countries;
        inputObject.companyType.options = companyTypes;
        inputObject.numberOfEmployees.options = numberOfEmployees;
        inputObject.jobFunction.options = functions;
        inputObject.language.languages = languages;
        inputObject.genericFields = genericFields;
        inputObject.specificFields = specificFields;
        return inputObject;
    }
}
exports.DhsInstallerComponent = DhsInstallerComponent;
exports.dhsInstallerComponent = new DhsInstallerComponent();
